import NoResultsGraphic from '@/../img/noresult.svg';
import React from 'react';
import styled from 'styled-components';

// Style wrapper with keyframe animation to try an achieve spring effect
const NoResultsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @keyframes growOnEnter {
    0% {
      transform: scale(0);
    }
    40% {
      transform: scale(1.1);
    }
    70% {
      transform: scale(1.3);
    }
    100% {
      transform: scale(1);
    }
  }

  animation: growOnEnter 0.3s;
`;

const StyledNoResultsTitleText = styled.span`
  font-size: 24px;
  padding: 26px 31px 20px 31px;
  font-weight: 600;
  line-height: 1;
  color: rgba(0, 0, 0, 0.65);
  :before {
    content: '${(props) => props.titleText}';
  }
`;

const DEFAULT_TEXT = {
  titleText: 'No matching results',
};

/**
 * Simple component that renders a no results message with title text, subtitle text
 * @param {param3} active used to kick off animation on prop change
 * @param {param2} subtitleText smaller text at the bottom of the message
 * @param {param1} titleText large text used to inform user there are no results to display
 */
function NoResultsMessage({ titleText, active }) {
  return (
    <NoResultsWrapper key={active}>
      <NoResultsGraphic />
      <StyledNoResultsTitleText
        titleText={titleText || DEFAULT_TEXT.titleText}
      />
    </NoResultsWrapper>
  );
}

export default NoResultsMessage;
